import { ROUTES } from 'constants/routes'
import i18n from 'i18next'

const BASIC_ACTIONS = [
  {
    type: 'budget',
    icon: 'calculator',
    isVisible: (statuses) => {
      if (statuses.length === 1 && statuses.includes('deleted')) {
        return false
      }

      return true
    },
  },
  {
    type: 'activate',
    icon: 'play',
    disableTooltip: (resource) =>
      i18n.t(`campaigns_editor::actions.disable_tooltips.activate`, {
        context: resource,
      }),
    isVisible: (statuses) => {
      if (statuses.length === 1 && statuses.includes('active')) {
        return false
      }

      if (statuses.includes('blocked') || statuses.includes('deleted')) {
        return true
      }

      return true
    },
    isDisabled: (statuses) => {
      if (statuses.includes('deleted')) {
        return true
      }

      return false
    },
  },
  {
    type: 'block',
    icon: 'pause-circle',
    isVisible: (statuses) => statuses.includes('active'),
  },
  {
    type: 'delete',
    icon: 'inbox-archive',
    isVisible: (statuses) =>
      !(statuses.length === 1 && statuses.includes('deleted')),
  },
  {
    type: 'restore',
    icon: 'recovery',
    isVisible: (statuses) => statuses.includes('deleted'),
  },
]

const getVisibleActions = (statuses) =>
  BASIC_ACTIONS.reduce((acc, item) => {
    if (item.isVisible(statuses)) {
      acc = acc.concat({
        ...item,
        disabled: item?.isDisabled && item.isDisabled(statuses),
      })
    }

    return acc
  }, [])

const RESOURCES = {
  campaigns: {
    route: ROUTES.SERVICES_NETWORK_CAMPAIGNS_EDITOR_CAMPAIGNS,
    actions: (statuses) => [...getVisibleActions(statuses)],
  },
  'ad-groups': {
    route: ROUTES.SERVICES_NETWORK_CAMPAIGNS_EDITOR_AD_GROUPS,
    actions: (statuses) => [...getVisibleActions(statuses)],
  },
  banners: {
    route: ROUTES.SERVICES_NETWORK_CAMPAIGNS_EDITOR_BANNERS,
    actions: getVisibleActions,
  },
}

export default RESOURCES
